<template>
  <div>
    <v-dialog v-model="value" persistent max-width="600px">
      <v-card>
        <v-card-title class="modal_title">
          <div class="circle">
            <v-icon color="success" size="30px">done</v-icon>
          </div>
        </v-card-title>
        <v-card-text>
          <!-- <p class="text">¡Colaborador creado con exito!</p> -->
          <p class="text">{{ content }}</p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  // content recive a text like so: Colaborador creado exitosamente
  props: ['value', 'content'],
  data: () => ({
    value: false,
  }),
  methods: {
    close() {
      this.$emit("input", !this.value);
    }
  },
  watch: {
    value(val) {
      if (!val) return
      setTimeout(() => (this.close()), 2000)
    }
  }
}
</script>

<style scoped>
.modal_title {
  display: flex;
  justify-content: center;
  padding-top: 25px;
  padding-bottom: 0px;
}

.circle {
  padding: 8px 10px;
  border-radius: 100%;
  background-color: #D1FAE5;
}

.circle i {
  font-size: 30px;
}

.text {
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  color: #111827;
  font-weight: 600;
  font-size: 24px;
}
</style>
